import React from "react";

export const QuestionMark = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16">
      <path
        fill="#27AE60"
        d="M8 1a7 7 0 100 14A7 7 0 008 1zm0 12.813A5.814 5.814 0 018 2.187a5.814 5.814 0 010 11.626z"></path>
      <path
        fill="#27AE60"
        d="M7.375 11.438a.625.625 0 100-.001zm2.369-6.49A2.651 2.651 0 008 4.312c-.656 0-1.275.225-1.744.636-.487.427-.756 1-.756 1.614v.12c0 .068.056.124.125.124h.75a.125.125 0 00.125-.125v-.119c0-.689.673-1.25 1.5-1.25s1.5.561 1.5 1.25c0 .486-.344.932-.875 1.136A1.747 1.747 0 007.5 9.352v.335c0 .07.056.126.125.126h.75a.126.126 0 00.125-.126v-.354a.75.75 0 01.483-.7c.922-.355 1.517-1.167 1.517-2.07 0-.615-.269-1.188-.756-1.615z"></path>
    </svg>
  );
};
